import {
  addObj,
  getAll,
  getPage,
  getDetail,
  modifyObj,
  deleteObj,
  getMyUserGroupAll,
  getMyUserGroupPage,
  getTeamReport,
  uploadMaintainPicture,
  removeMaintainPicture,
  cancel,
  confirmMaintained
} from '@/api/technicalassistanceserv'

export default {
  state: {
    state_TechnicalAssistance_AddObjResult: null,
    state_TechnicalAssistance_GetAllResult: null,
    state_TechnicalAssistance_GetPageResult: null,
    state_TechnicalAssistance_GetDetailResult: null,
    state_TechnicalAssistance_ModifyObjResult: null,
    state_TechnicalAssistance_DeleteObjResult: null,
    state_TechnicalAssistance_GetMyUserGroupAllResult: null,
    state_TechnicalAssistance_GetMyUserGroupPageResult: null,
    state_TechnicalAssistance_GetTeamReportResult: null,
    state_TechnicalAssistance_UploadMaintainPictureResult: null,
    state_TechnicalAssistance_RemoveMaintainPictureResult: null,
    state_TechnicalAssistance_CancelResult: null,
    state_TechnicalAssistance_ConfirmMaintainedResult: null
  },
  mutations: {
    SET_TECHNICALASSISTANCE_ADDOBJ_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_AddObjResult = rst
    },
    SET_TECHNICALASSISTANCE_GETALL_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetAllResult = rst
    },
    SET_TECHNICALASSISTANCE_GETPAGE_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetPageResult = rst
    },
    SET_TECHNICALASSISTANCE_GETDETAIL_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetDetailResult = rst
    },
    SET_TECHNICALASSISTANCE_MODIFYOBJ_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_ModifyObjResult = rst
    },
    SET_TECHNICALASSISTANCE_DELETEOBJ_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_DeleteObjResult = rst
    },
    SET_TECHNICALASSISTANCE_GETMYUSERGROUPALL_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetMyUserGroupAllResult = rst
    },
    SET_TECHNICALASSISTANCE_GETMYUSERGROUPPAGE_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetMyUserGroupPageResult = rst
    },
    SET_TECHNICALASSISTANCE_GETTEAMREPORT_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_GetTeamReportResult = rst
    },
    SET_TECHNICALASSISTANCE_UPLOADMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_UploadMaintainPictureResult = rst
    },
    SET_TECHNICALASSISTANCE_REMOVEMAINTAINPICTURE_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_RemoveMaintainPictureResult = rst
    },
    SET_TECHNICALASSISTANCE_CANCEL_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_CancelResult = rst
    },
    SET_TECHNICALASSISTANCE_CONFIRMMAINTAINED_RESULT: (state, rst) => {
      state.state_TechnicalAssistance_ConfirmMaintainedResult = rst
    }
  },
  actions: {
    TechnicalAssistanceServ_AddObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        addObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_ADDOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_ADDOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetDetail ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETDETAIL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETDETAIL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_ModifyObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        modifyObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_MODIFYOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_MODIFYOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_DeleteObj ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        deleteObj(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_DELETEOBJ_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_DELETEOBJ_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetMyUserGroupAll ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupAll(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETMYUSERGROUPALL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETMYUSERGROUPALL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetMyUserGroupPage ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getMyUserGroupPage(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETMYUSERGROUPPAGE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETMYUSERGROUPPAGE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_GetTeamReport ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        getTeamReport(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_GETTEAMREPORT_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_GETTEAMREPORT_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_UploadMaintainPicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        uploadMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_UPLOADMAINTAINPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_UPLOADMAINTAINPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_RemoveMaintainPicture ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        removeMaintainPicture(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_REMOVEMAINTAINPICTURE_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_REMOVEMAINTAINPICTURE_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_Cancel ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        cancel(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_CANCEL_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_CANCEL_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    TechnicalAssistanceServ_ConfirmMaintained ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        confirmMaintained(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_TECHNICALASSISTANCE_CONFIRMMAINTAINED_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_TECHNICALASSISTANCE_CONFIRMMAINTAINED_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_TechnicalAssistance_AddObjResult: state => {
      return state.state_TechnicalAssistance_AddObjResult
    },
    get_TechnicalAssistance_GetAllResult: state => {
      return state.state_TechnicalAssistance_GetAllResult
    },
    get_TechnicalAssistance_GetPageResult: state => {
      return state.state_TechnicalAssistance_GetPageResult
    },
    get_TechnicalAssistance_GetDetailResult: state => {
      return state.state_TechnicalAssistance_GetDetailResult
    },
    get_TechnicalAssistance_ModifyObjResult: state => {
      return state.state_TechnicalAssistance_ModifyObjResult
    },
    get_TechnicalAssistance_DeleteObjResult: state => {
      return state.state_TechnicalAssistance_DeleteObjResult
    },
    get_TechnicalAssistance_GetMyUserGroupAllResult: state => {
      return state.state_TechnicalAssistance_GetMyUserGroupAllResult
    },
    get_TechnicalAssistance_GetMyUserGroupPageResult: state => {
      return state.state_TechnicalAssistance_GetMyUserGroupPageResult
    },
    get_TechnicalAssistance_GetTeamReportResult: state => {
      return state.state_TechnicalAssistance_GetTeamReportResult
    },
    get_TechnicalAssistance_UploadMaintainPictureResult: state => {
      return state.state_TechnicalAssistance_UploadMaintainPictureResult
    },
    get_TechnicalAssistance_RemoveMaintainPictureResult: state => {
      return state.state_TechnicalAssistance_RemoveMaintainPictureResult
    },
    get_TechnicalAssistance_CancelResult: state => {
      return state.state_TechnicalAssistance_CancelResult
    },
    get_TechnicalAssistance_ConfirmMaintainedResult: state => {
      return state.state_TechnicalAssistance_ConfirmMaintainedResult
    }
  }
}
